<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-31 09:40:30
 * @LastEditors: ZhaoDong
 * @LastEditTime: 2022-11-03 19:26:13
 * @Description: 用户选择
-->
<template>
  <a-select
    showSearch
    :disabled="disabled"
    :getPopupContainer="getParentContainer"
    @search="loadData"
    :placeholder="placeholder"
    v-model="selectedValue"
    style="width: 100%"
    class="yz-staff-select"
    :class="{ 'is-disabled': readOnly }"
    :filterOption="false"
    :showArrow="true"
    @change="handleChange"
    allowClear
    :defaultActiveFirstOption="defaultActiveFirstOption"
  >
    <a-icon slot="suffixIcon" type="user" />
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <div slot="notFoundContent" v-else-if="options.length === 0">{{ notFoundText }}</div>
    <a-select-option v-for="d in options" :key="d.user_id" :value="d.user_id">
      {{ d.mobile }} ({{ d.username }})
    </a-select-option>
  </a-select>
</template>

<script>
import debounce from 'lodash/debounce'
import api from '@/api/'
export default {
  name: 'StaffSelect',
  props: {
    disabled: Boolean,
    readOnly: Boolean,
    value: {
      type: [String, Number],
      require: false,
      default: () => null
    },
    placeholder: {
      type: String,
      default: '请输入姓名或工号',
      required: false
    },
    notFoundText: {
      type: String,
      default: '无数据'
    },
    popContainer: {
      type: String,
      default: '',
      required: false
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    defaultActiveFirstOption: Boolean
  },
  data() {
    this.lastLoad = 0
    this.loadData = debounce(this.loadData, 800)
    return {
      loading: false,
      selectedValue: undefined,
      options: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.selectedValue = undefined
          this.options = []
        } else {
          this.initSelectValue()
        }
      }
    }
  },
  methods: {
    handleChange(value) {
      if (value) {
        this.selectedValue = value
      } else {
        this.selectedValue = undefined
        this.options = []
      }
      this.callback()
    },
    /* 初始化已选 */
    initSelectValue() {
      if (!this.value) return
      if (!this.selectedValue || this.selectedValue !== this.value) {
        api.QueryUser({ username: this.value }).then(({ data }) => {
          if (data?.total > 0) {
            const _userTempList = data?.list ?? []
            this.options = _userTempList
            const _user = this.options.find(item => item.user_id === this.value)
            if (_user) this.selectedValue = this.value
          }
        })
      } else {
        this.selectedValue = this.value
        // this.options = []
      }
    },

    loadData(value) {
      if (!value) return
      this.lastLoad += 1
      const currentLoad = this.lastLoad
      this.options = []
      this.loading = true
      api.QueryUser({ username: value, ...this.params }).then(({ data }) => {
        if (currentLoad !== this.lastLoad) {
          return
        }
        if (data?.total > 0) {
            const _userTempList = data?.list ?? []
            this.options = _userTempList
            const _user = this.options.find(item => item.user_id === this.value)
            if (_user) this.selectedValue = this.value
          }
      }).finally(() => {
        this.loading = false
      })
    },
    /* 后悬浮层位置 */
    getParentContainer(node) {
      if (!this.popContainer) {
        return node.parentNode
      } else {
        return document.querySelector(this.popContainer)
      }
    },
    callback() {
      this.$emit('change', this.selectedValue)
    },
    clearOptions() {
      this.options = []
      this.selectedValue = null
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style scoped lang="less">
.yz-staff-select {
  /deep/ .ant-select-arrow-icon svg {
    transform: rotate(0deg) !important;
  }

  &.is-disabled {
    display: inline-block;
    width: auto !important;
    pointer-events: none;
    /deep/ .ant-select-selection {
      border: 0;
      .ant-select-selection__rendered {
        margin: 0;
      }
      .ant-select-selection__clear,
      .ant-select-arrow {
        display: none;
      }
    }
  }
}
</style>
